import React from "react";
import { CHAR_LIMITS, TC_RADIUS } from "../../constants/templateCreatorConstants";
import { validateFooter } from "../../utils/templateCreatorValidation";
import FormFieldError from "./FormFieldError";

const FooterEditor = ({ footer, onFooterChange }) => {
  const error = validateFooter(footer);

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="text-[13px] font-semibold text-[#050505]">
          Footer · Optional
        </label>
        <span className="text-[12px] text-[#65676b] tabular-nums">
          {footer.length}/{CHAR_LIMITS.FOOTER}
        </span>
      </div>
      <input
        type="text"
        value={footer}
        onChange={(e) => onFooterChange(e.target.value)}
        placeholder="Add a short line of text to the bottom of your message"
        maxLength={CHAR_LIMITS.FOOTER}
        className={`w-full px-3 py-2 text-[15px] border focus:outline-none transition-colors bg-white ${TC_RADIUS} ${
          error
            ? "border-red-300"
            : "border-[#ccd0d5] focus:border-[#1877f2]"
        }`}
      />
      <FormFieldError message={error} reserve={false} />
    </div>
  );
};

export default FooterEditor;
